"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegFormFooterContent = void 0;
var RegFormFooterContent_1 = require("./RegFormFooterContent");
Object.defineProperty(exports, "RegFormFooterContent", { enumerable: true, get: function () { return __importDefault(RegFormFooterContent_1).default; } });
//# sourceMappingURL=index.js.map